import DownPaymentsForm from './DownPaymentsForm'
export default DownPaymentsForm
